import { Box } from 'braid-design-system';
import * as styles from './SkeletonLoader.css';

export const SkeletonLoader = () => {
  return (
    <Box
      className={styles.skeletonLoader}
      data={{ testid: 'skeleton-loader' }}
    />
  );
};
